import styles from "./StatusCard.module.scss";
import { StatusCardStatus } from "./utils";


interface Props {
    title: string;
    status: StatusCardStatus;
}

const StatusCard = ({ title, status }: Props) => {
    return (
        <div className={styles.statusCard}>
            <div className={styles.statusCardContents}>
                <h3>{title}</h3>
                {renderStatus(status)}
            </div>
        </div>
    );
};

const renderStatus = (status: StatusCardStatus) => {
    return (
        <div className={styles.status}>
            {statusSvgs[status]}
            <p
                className={`${styles.statusText} ${
                    status === StatusCardStatus.IN_PROGRESS
                        ? styles.statusTextInProgress
                        : styles[`statusText${status}`]
                }`}
            >
                {status}
            </p>
        </div>
    );
};

const successSvg = (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Success</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM3.58579 8L5 6.58579L7 8.58579L10.52 5.06579L11.9342 6.48L7 11.4142L3.58579 8Z"
            fill="#037F0C"
        />
    </svg>
)

const errorSvg = (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Error</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM6.58579 8L4.46289 10.1229L5.87711 11.5371L8 9.41421L10.1229 11.5371L11.5371 10.1229L9.41421 8L11.5371 5.87711L10.1229 4.46289L8 6.58579L5.87711 4.46289L4.46289 5.87711L6.58579 8Z"
            fill="#D91515"
        />
    </svg>
)

const statusSvgs = {
    [StatusCardStatus.SUCCESS]: successSvg,
    [StatusCardStatus.CONFIRMED]: successSvg,
    [StatusCardStatus.ERROR]: errorSvg,
    [StatusCardStatus.CANCELLED]: errorSvg,
    [StatusCardStatus.IN_PROGRESS]: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>In progress</title>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14ZM6 9H4V7H6V9ZM11.994 9H9.994V7H11.994V9ZM7 9H9V7H7V9Z"
                fill="#5F6B7A"
            />
        </svg>
    ),
    [StatusCardStatus.PENDING]: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Pending</title>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM7 4V8H4V10H7H9V8V4H7Z"
                fill="#5F6B7A"
            />
        </svg>
    ),
};

export default StatusCard;
